import { createContext, useState } from 'react';

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
    const [success, setSuccess] = useState(false);
    const [user, setUser] = useState({
        token: '' || localStorage.getItem('token'),
        fullName: '',
        email: '',
        lvl: 0
    });
    const [preUser, setPreUser] = useState('');
    const [publicKey, setPublicKey] = useState('');
    const [serverDown, setServerDown] = useState(false);
    const [decodeState, setDecodeState] = useState({
        loaded: false
    });
    const [userInfo, setUserInfo] = useState({
        loaded: false
    });
    const [businessInfo, setBusinessInfo] = useState({
        loaded: false,
        banks: [],
        owners: []
    });
    const [isBusinessLoading, setIsBusinessLoading] = useState(true);
    const [hasAccount, setHasAccount] = useState(false);
    const [publicSettings, setPublicSettings] = useState({});

    const setSucc = val => {
        setSuccess(val);
    };

    const loginUser = val => {
        setUser(val);
    };

    const removeToken = () => {
        setUser({
            token: '',
            fullName: '',
            email: ''
        });
    };

    return (
        <AuthContext.Provider
            value={{
                preUser,
                setPreUser,
                user,
                loginUser,
                removeToken,
                setSucc,
                success,
                decodeState,
                setDecodeState,
                setBusinessInfo,
                businessInfo,
                hasAccount,
                setHasAccount,
                setUserInfo,
                userInfo,
                isBusinessLoading,
                setIsBusinessLoading,
                publicKey,
                setPublicKey,
                serverDown,
                setServerDown,
                publicSettings,
                setPublicSettings
            }}>
            {children}
        </AuthContext.Provider>
    );
};
